const isEnterKey = (event: KeyboardEvent): boolean => {
  return event.key === 'Enter' || event.code === 'Enter';
};

const isShiftEnterKey = (event: KeyboardEvent): boolean => {
  return (event.key === 'Enter' || event.code === 'Enter') && event.shiftKey;
};

const isShiftKey = (event: KeyboardEvent): boolean => {
  return event.key === 'Shift' || event.code === 'ShiftLeft' || event.code === 'ShiftRight';
};

const isEscapeKey = (event: KeyboardEvent): boolean => {
  return event.key === 'Escape' || event.code === 'Escape';
};

const isTabKey = (event: KeyboardEvent): boolean => {
  return event.key === 'Tab' || event.code === 'Tab';
};

export const Keyboard = {
  isEnterKey,
  isShiftEnterKey,
  isShiftKey,
  isEscapeKey,
  isTabKey,
};
